var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isBeta)?_c('VChip',{staticClass:"ml-1 my-0 justify-start beta-label",attrs:{"label":"","small":"","color":_vm.color,"text-color":_vm.textColor}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }